import completeLogo from "../../assets/images/canaryPointCS_logo.png";
import mediaBackground from "../../assets/images/media_background.png";
import amfb from "../../assets/images/amfb.png";
import monieTree from "../../assets/images/monieTree.png";
import teamBonding from "../../assets/images/teamBonding.png";
import blankImage from "../../assets/images/blankImage.png";
import investmentBanking from "../../assets/img/whatwedo-img/Investment-Banking.jpg";
import assets from "../../assets/images/Assets.png";
import canaryPointLogo from "../../assets/images/canaryPointLogo.png";
import instantCash from "../../assets/images/InstantCash.png";
import monie_tree from "../../assets/images/Monie_Tree.png";
import nairagram from "../../assets/images/Nairagram.png";
import sebastian from "../../assets/images/Sebastian.png";
import swiftandallied from "../../assets/images/Swift&Allied.png";
import financialSolutions from "../../assets/images/financialSolutions.png";

import patnership from "../../assets/images/patnership.png";
import investmentBankingImg from "../../assets/images/investmentBankingImg.png";
import microFinanceBankingImg from "../../assets/images/microFinanceBankingImg.png";
import remittanceImg from "../../assets/images/remittanceImg.png";
import bdc_Img from "../../assets/images/bdc_Img.png";
import productsImg from "../../assets/img/whatwedo-img/productsImage.jpg";

const Images = {
  completeLogo,
  amfb,
  monieTree,
  teamBonding,
  blankImage,
  mediaBackground,
  investmentBanking,
  assets,
  canaryPointLogo,
  instantCash,
  monie_tree,
  nairagram,
  sebastian,
  swiftandallied,
  financialSolutions,
  patnership,
  investmentBankingImg,
  microFinanceBankingImg,
  remittanceImg,
  bdc_Img,
  productsImg,
};
export default Images;
